export enum  UIStatesEnum {
  CREATE = 1,
  VIEW,
  EDIT,
  PACKING,
}
